import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import {
  PrimaryButton,
  ButtonSizes,
} from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';

import { AtlassianAccountOnboardingLinks } from '../AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';
import { MemberAvatar } from 'app/src/components/MemberAvatar';
import Icon, { IconName, IconColor } from 'app/common/components/controls/icon';
import { aaManagedProfileUrl } from '@trello/config';

const format = forNamespace(['aa onboarding', 'dialog'], {
  shouldEscapeStrings: false,
});

interface NotWorkProps {
  id: string;
  name: string;
  aaEmail: string;
  orgName: string;
  onDismiss: () => void;
  onClickOk: () => void;
}

export const AtlassianConfirmation: FunctionComponent<NotWorkProps> = ({
  id,
  name,
  aaEmail,
  orgName,
  onDismiss,
  onClickOk,
}) => (
  <OnboardingDialog
    title={format('account connected title')}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    closeDialog={onDismiss}
    className={styles.notWorkBody}
  >
    <div className={styles.confirmationContent}>
      <div className={styles.leftSection}>
        <MemberAvatar size={64} idMember={id} />
        <p>{name}</p>
        <span>{aaEmail}</span>
      </div>
      <div className={styles.rightSection}>
        <div className={styles.listItem}>
          <Icon
            large
            className={styles.atlassianConfirmationIcon}
            color={IconColor.Green}
            name={IconName.Check}
          />
          <span>{format('fron now on')}</span>
        </div>
        <div className={styles.listItem}>
          <Icon
            large
            className={styles.atlassianConfirmationIcon}
            color={IconColor.Green}
            name={IconName.Check}
          />
          <span>
            {format('to review profile')}{' '}
            <a href={aaManagedProfileUrl}>
              <u>{format('atlassian profile')}</u>
            </a>
          </span>
        </div>
        <div className={styles.listItem}>
          <Icon
            large
            className={styles.atlassianConfirmationIcon}
            color={IconColor.Green}
            name={IconName.Check}
          />
          <span>
            {format('non org boards', { org: orgName })}
            <a href={AtlassianAccountOnboardingLinks.TransferBoards}>
              <u> {format('transfer to personal')}</u>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div className={styles.section}>
      <PrimaryButton size={ButtonSizes.WIDE} onClick={onClickOk}>
        {format('got it')}
      </PrimaryButton>
    </div>
  </OnboardingDialog>
);
